import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import withDynamicReducer from '@tcp/core/src/components/common/hoc/withDynamicReducer';
import useDynamicSaga from '@tcp/core/src/components/common/hoc/withDynamicSaga';
import { getAISearchEnabled } from '@tcp/core/src/reduxStore/selectors/session.selectors';
import AIAssistantView from '../views';
import { getChatSummary, getLoadingState } from './AIAssistant.selectors';
import { fetchResponse, setChatSummaryQ } from './AIAssistant.actions';
import AIAssistantReducer from './AIAssistant.reducer';
import AIAssistantSaga from './AIAssistant.saga';

const AIAssistantContainer = (props) => {
  return <AIAssistantView {...props} />;
};

export const mapStateToProps = (state) => {
  return {
    chatSummary: getChatSummary(state),
    enableAISearch: getAISearchEnabled(state),
    isLoading: getLoadingState(state),
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {
    fetchResponse: (payload) => dispatch(fetchResponse(payload)),
    setChatSummaryQ: (payload) => dispatch(setChatSummaryQ(payload)),
  };
};

const withReducer = withDynamicReducer({ key: 'AIAssistant', reducer: AIAssistantReducer });
const withSaga = useDynamicSaga({ key: 'AIAssistantSaga', saga: AIAssistantSaga });
const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withReducer, withSaga, withConnect)(AIAssistantContainer);
